module.exports = __webpack_public_path__ + "static/media/warning.6e0e8af4.svg";